import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "../scss/posts.scss";

export default function AzureCourse() {
  const nameExt = " | charlie-gp";
  const [postTitle, postDate, readTime] = [
    "An intro to DevOps",
    "Nov. 9, 2022",
    "4min. read",
  ];

  return (
    <div id="posts">
      <Helmet>
        <title>{postTitle + nameExt}</title>
      </Helmet>
      <div id="post-date">
        <small>
          {postDate} &nbsp;&bull;&nbsp; {readTime} &nbsp;&bull;&nbsp;{" "}
          <Link to="/blog/">Blog</Link>
        </small>
      </div>

      <p id="post-title">{postTitle}</p>

      <br />
      <p className="post-sect">
        Experience CI/CD with <a href="https://www.vercel.com">Vercel</a>
      </p>
      <p>
        It is really an exciting feeling to learn stuff that is new to you. It's
        been a couple of years since I was on the field of non-coding job. When
        I get back on track, it's a mind blowing how things are to be done on
        software development cycle. CI/CD is Amazing!
      </p>
      <p>
        <img src="/images/shots/vercel-dashboard.png" alt="vercel dashboard" />
        <small>Photo: Vercel Dashboard</small>
      </p>
      <br />

      <p className="post-sect">Experience Cloud with Azure</p>
      <p>
        Thank you <a href="https://learn.microsoft.com">learn.microsoft.com</a>,
        as usual, the documentation is excellent, easy to comprehend, all we
        have to do is to follow and learn. I've tried using Azure Shell via
        Sandbox, configured NGINX HTTP Server, and created Azure Storage with
        blob container. Woah!
      </p>
      <img
        src="/images/shots/azure-blob-container.png"
        alt="demo add readme.md file"
      />
      <small>Photo: Azure Storage</small>

      <br />
      <br />
      <p className="post-sect">Enclosing</p>
      <p>🤟These shits are so f**ing Stimulating!</p>
      <p className="text-end">
        <a href="#root">
          <i className="bi-arrow-up"></i> Back to top
        </a>
      </p>
    </div>
  );
}
